import { render, staticRenderFns } from "./ChatDisplay.vue?vue&type=template&id=764d2bf6&scoped=true"
import script from "./ChatDisplay.vue?vue&type=script&lang=js"
export * from "./ChatDisplay.vue?vue&type=script&lang=js"
import style0 from "./ChatDisplay.vue?vue&type=style&index=0&id=764d2bf6&prod&lang=scss"
import style1 from "./ChatDisplay.vue?vue&type=style&index=1&id=764d2bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764d2bf6",
  null
  
)

export default component.exports